import {defineMessages} from "@project/i18n";

export const taskFieldLabelIds = {
  dueAt: "fields.task.dueAt",
  status: "fields.task.status",
  title: "fields.task.title",
} as const;

export const taskFieldMessages = defineMessages({
  dueAt: {
    id: "fields.task.dueAt",
    defaultMessage: "Due date",
    description: "Task field label for due date",
  },
  status: {
    id: "fields.task.status",
    defaultMessage: "Status",
    description: "Task field label for status",
  },
  title: {
    id: "fields.task.title",
    defaultMessage: "Title",
    description: "Task field label for title",
  },
});
